var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {


















pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};






































pug_html = pug_html + "\u003Ch2\u003ECreate loan request from loan enquiry\u003C\u002Fh2\u003E\u003Cp\u003E Select the borrower from the linked businesses associated with this loan enquiry. \nThis will default the \u003Cb\u003EBorrower name\u003C\u002Fb\u003E, and \u003Cb\u003ETrading since\u003C\u002Fb\u003E fields. All fields are editable.\u003C\u002Fp\u003E\u003Cform layout=\"column\" layout-padding flex name=\"vm.createForm\" api-form=\"vm.confirmAction()\"\u003E\u003Cdiv class=\"border-1\"\u003E\u003Cinput-container class=\"borrower\" label=\"Borrower (type) ABN\u002FACN : Name\"\u003E\u003Cmd-select class=\"banana required-select big-list\" required name=\"borrowerId\" ng-model=\"vm.borrowerId\" aria-label=\"Borrower\"\u003E\u003Cmd-option ng-repeat=\"business in vm.businesses\" value=\"{{business.id}}\"\u003E \u003Cspan class=\"led-borrower-type\"\u003E{{business.type}}\u003C\u002Fspan\u003E\u003Cspan class=\"led-borrower-abnAcn\"\u003E{{business.abnAcn}}\u003C\u002Fspan\u003E\u003Cspan class=\"led-borrower-name\"\u003E{{business.name}}\u003C\u002Fspan\u003E\u003C\u002Fmd-option\u003E\u003C\u002Fmd-select\u003E\u003Cdiv class=\"md-errors-spacer\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Borrower name\"\u003E\u003Cinput required name=\"borrowerName\" ng-model=\"vm.borrowerName\" type=\"text\"\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Trading since\"\u003E\u003Cinput required name=\"tradingSince\" ng-model=\"vm.tradingSince\" type=\"text\"\u003E\u003C\u002Finput-container\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"border-1\"\u003E\u003Cinput-container label=\"Loan amount\"\u003E\u003Cinput required name=\"loanAmount\" ng-model=\"vm.loanAmount\" ng-currency type=\"text\" min=\"00.00\" step=\"0.01\"\u003E\u003C!-- TODO: Validation on the amount - greater than zero?--\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Loan term (months)\"\u003E\u003Cinput required name=\"loanTerm\" ng-model=\"vm.loanTerm\" type=\"text\"\u003E\u003C!-- TODO: Validation on the term - greater than zero?--\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Loan purpose\"\u003E\u003Cinput required name=\"loanPurpose\" ng-model=\"vm.loanPurpose\" type=\"text\"\u003E\u003C\u002Finput-container\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\" layout=\"row\"\u003E\u003Cmd-button class=\"md-raised md-primary create\" type=\"submit\"\u003ECreate!\u003C\u002Fmd-button\u003E\u003Cmd-button class=\"md-raised cancel\" type=\"button\" ng-click=\"vm.cancelAction()\"\u003ECancel\u003C\u002Fmd-button\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;